import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FileUploadAwareJsonWriterClass;
function FileUploadAwareJsonWriter() {
  if (FileUploadAwareJsonWriterClass === VOID) {
    class $ {
      constructor(wrappedWriter) {
        this.d48_1 = wrappedWriter;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.e48_1 = LinkedHashMap().gc();
      }
      f48() {
        return this.e48_1;
      }
      f41() {
        // Inline function 'kotlin.apply' call
        this.d48_1.f41();
        return this;
      }
      g41() {
        // Inline function 'kotlin.apply' call
        this.d48_1.g41();
        return this;
      }
      a41() {
        // Inline function 'kotlin.apply' call
        this.d48_1.a41();
        return this;
      }
      b41() {
        // Inline function 'kotlin.apply' call
        this.d48_1.b41();
        return this;
      }
      c48(name) {
        // Inline function 'kotlin.apply' call
        this.d48_1.c48(name);
        return this;
      }
      m41(value) {
        // Inline function 'kotlin.apply' call
        this.d48_1.m41(value);
        return this;
      }
      w41(value) {
        // Inline function 'kotlin.apply' call
        this.d48_1.w41(value);
        return this;
      }
      r41(value) {
        // Inline function 'kotlin.apply' call
        this.d48_1.r41(value);
        return this;
      }
      o41(value) {
        // Inline function 'kotlin.apply' call
        this.d48_1.o41(value);
        return this;
      }
      u41(value) {
        // Inline function 'kotlin.apply' call
        this.d48_1.u41(value);
        return this;
      }
      s4a(value) {
        // Inline function 'kotlin.apply' call
        this.d48_1.s4a(value);
        return this;
      }
      b42(value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.e48_1;
        // Inline function 'kotlin.collections.set' call
        var key = this.d48_1.h4a();
        tmp0.c5(key, value);
        this.d48_1.f40();
        return this;
      }
      f40() {
        // Inline function 'kotlin.apply' call
        this.d48_1.f40();
        return this;
      }
      h4a() {
        return this.d48_1.h4a();
      }
      q6() {
        this.d48_1.q6();
      }
    }
    initMetadataForClass($, 'FileUploadAwareJsonWriter');
    FileUploadAwareJsonWriterClass = $;
  }
  return FileUploadAwareJsonWriterClass;
}
//region block: exports
export {
  FileUploadAwareJsonWriter as FileUploadAwareJsonWriter1mx337tg0y9oj,
};
//endregion

//# sourceMappingURL=FileUploadAwareJsonWriter.mjs.map
